import React from 'react';
import classes from '../courses.module.css';
import IntlMessage from '../../../components/IntlMessage/IntlMessage';

/**
 * Заголовок секции с фирменным подчёркиванием — тем же приёмом, что на странице EMBA.
 * Принимает либо ключ локализации, либо готовую строку.
 */
const SectionTitle = ({id, text, as: Tag = 'h2', className}) => (
    <div className={className}>
        <Tag className={classes.sectionTitle}>
            {id ? <IntlMessage id={id}/> : text}
        </Tag>
        <div className={classes.sectionTitleBar}/>
    </div>
);

export default SectionTitle;
